import { REGISTRATION_TAB } from '@constants/registration';
import { UUID_REGEX } from '@constants/routes';
import { generatePath } from '@helpers/route';

const PATH = '/settings/jurisdictions';

const ENTITY_ID = `:entityId(${UUID_REGEX})`;
const FILING_ID = `:filingId(${UUID_REGEX})`;
const ENTITY_JURISDICTION_ID = `:entityJurisdictionId(${UUID_REGEX})`;
const MAPPING_ID = `:mappingId(${UUID_REGEX})`;
const REG_ID = `:regId(${UUID_REGEX})`;

export const jurisdictionsRoutes = {
  ROOT: {
    get rule() {
      return PATH;
    },
    get make() {
      return () => this.rule;
    },
  },
  LIST: {
    get rule() {
      return `${PATH}/${ENTITY_ID}?/:add(add)?`;
    },
    get make() {
      return (entityId?: string, add?: string) =>
        generatePath(this.rule, { entityId, add: add ? 'add' : undefined });
    },
  },
  DETAIL: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/:tab(${Object.values(
        REGISTRATION_TAB
      ).join('|')})?/:add(add)?`;
    },
    get make() {
      return ({
        entityId,
        entityJurisdictionId,
        tab = REGISTRATION_TAB.ACTIVE,
        add,
      }: {
        entityId: string;
        entityJurisdictionId: string;
        tab?: typeof REGISTRATION_TAB[keyof typeof REGISTRATION_TAB];
        add?: boolean;
      }) =>
        generatePath(this.rule, {
          entityId,
          entityJurisdictionId,
          tab,
          add: add ? 'add' : undefined,
        });
    },
  },
  REG_DETAIL: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/registration/${REG_ID}`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string, regId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId, regId });
    },
  },
  EDIT: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/registration/${REG_ID}/:edit(edit)`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string, regId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId, regId, edit: 'edit' });
    },
  },
  DE_REGISTER: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/registration/${REG_ID}/:deregister(deregister)`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string, regId: string) =>
        generatePath(this.rule, {
          entityId,
          entityJurisdictionId,
          regId,
          deregister: 'deregister',
        });
    },
  },
  FILING_TYPES_ADD: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/filing/:add(add)`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId, add: 'add' });
    },
  },
  FILING_TYPES_EDIT: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/filing/${FILING_ID}/:edit(edit)`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string, filingId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId, filingId, edit: 'edit' });
    },
  },
  MAPPING: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/mapping`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId });
    },
  },
  EDIT_MAPPING: {
    get rule() {
      return `${PATH}/${ENTITY_ID}/${ENTITY_JURISDICTION_ID}/mapping/${MAPPING_ID}/edit`;
    },
    get make() {
      return (entityId: string, entityJurisdictionId: string, mappingId: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId, mappingId });
    },
  },
};
